import { memo } from 'react';

import DashboardSection from './DashboardSection';
import DashboardStatusAndReviewCharts from './DashboardStatusAndReviewCharts';
import type { TDashboardStatusChartDatum, TDashboardViewCounters } from '../types/dashboard.types';

type TProps = {
  counters: TDashboardViewCounters;
  statusChart: TDashboardStatusChartDatum[];
};

const DashboardStatusOverview = ({ counters, statusChart }: TProps) => (
  <DashboardSection title="Status and periodic review overview">
    <DashboardStatusAndReviewCharts counters={counters} statusChart={statusChart} />
  </DashboardSection>
);

export default memo(DashboardStatusOverview);
